module.exports = __webpack_public_path__ + "static/img/10.4a7dccd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/10.png
// module id = Tvkv
// module chunks = 0